import store from '@/store'
import router from '@/router'

import UserService from '@/service/user/UserService'
import StatusService from '@/service/status/StatusService'

export default [{
  name: 'kyc/form',
  path: '/kyc/form',
  async beforeEnter(to, from, next) {
    let user = store.getters['auth/getProfile']
    let isExistingCustomer = await UserService.isExistingCustomer()
    let status = store.getters['status/getStatus']
    if (!isExistingCustomer && user.kyc && user.kyc.mobile_verification_is_done) {
      if (StatusService.statuses.NO_CFA_ACCOUNT.code === status.code) {
        await router.push({ name: 'cardsales/form' })
      } else {
        next({ name: 'factoring/form' })
      }
    } else if (isExistingCustomer && user.kyc && user.kyc.mobile_verification_is_done) {
      next({ name: 'kyc/verify-id-card' })
    } else {
      next()
    }
  },
  component: require('@/views/kyc/KycForm.vue').default
}, {
  name: 'kyc/verify-id',
  path: '/kyc/verify-id',
  async beforeEnter(to, from, next) {
    let user = store.getters['auth/getProfile']
    if (user.kyc && user.kyc.mobile_verification_is_done) {
      let confirm = await window.$swal.fire({
        html: '본인 인증이 완료됐습니다.',
        confirmButtonText: '확인'
      })
      if (confirm.isConfirmed) {
        next({ name: 'dashboard' })
      }
    } else {
      next()
    }
  },
  component: require('@/views/kyc/KycIdVerify.vue').default
}, {
  name: 'kyc/verify-id/fail',
  path: '/kyc/verify-id/fail',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/kyc/KycIdVerifyFail.vue').default
}, {
  name: 'kyc/verify-id/success',
  path: '/kyc/verify-id/success',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/kyc/KycIdVerifySuccess.vue').default
}, {
  name: 'kyc/verify-id-card',
  path: '/kyc/verify-id-card',
  async beforeEnter(to, from, next) {
    let isExistingCustomer = await UserService.isExistingCustomer()
    let user = store.getters['auth/getProfile']
    if (!isExistingCustomer && user.kyc && user.kyc.id_card_verification_is_done) {
      window.$swal.fire({
        html: '신분증 인증이 완료됐습니다.',
        confirmButtonText: '확인'
      })
    } else if (isExistingCustomer && user.kyc && user.kyc.id_card_verification_is_done) {
      next({ name: 'kyc/verify-withdrawal-account' })
    } else {
      next()
    }
  },
  component: require('@/views/kyc/KycVerifyIdCard.vue').default
}, {
  name: 'kyc/verify-withdrawal-account',
  path: '/kyc/verify-withdrawal-account',
  async beforeEnter(to, from, next) {
    let user = store.getters['auth/getProfile']
    if (user.kyc && user.kyc.bank_verification_is_done) {
      let confirm = await window.$swal.fire({
        html: '출금계좌 인증이 완료됐습니다.',
        confirmButtonText: '확인'
      })
      if (confirm.isConfirmed) {
        next({ name: 'dashboard' })
      }
    } else {
      next()
    }
  },
  component: require('@/views/kyc/KycVerifyWithdrawalAccount.vue').default
}]
